import { Component } from 'react'
import { autobind } from 'core-decorators'

import { lg } from 'common/utils/breakpoints'
import { addFixedToBody, moveBackAfterClose } from 'common/utils/modalScroll'


export default function withSidebarHOC(ComposedComponent) {
  class withSidebarHOCContainer extends Component {
    state = {
      openSidebar: false,
    }

    @autobind
    setSidebarOpen(open) {
      if(open === this.state.openSidebar) {
        return
      }
      this.setState({ openSidebar: open }, () => {
        if(open) {
          addFixedToBody()
        } else {
          moveBackAfterClose()
        }
      })
    }

    @autobind
    toggleSidebar() {
      this.setSidebarOpen(!this.state.openSidebar)
    }

    @autobind
    onResizeWindow() {
      if(!(typeof window === 'undefined') && window.innerWidth > lg && this.state.openSidebar) {
        this.toggleSidebar()
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.onResizeWindow)
      moveBackAfterClose()
    }

    render() {
      if(!(typeof window === 'undefined')) {
        window.addEventListener('resize', this.onResizeWindow)
      }
      return (
        <ComposedComponent
          {...this.props}
          {...this.state}
          toggleSidebar={this.toggleSidebar}
          setSidebarOpen={this.setSidebarOpen}
        />
      )
    }
  }

  return withSidebarHOCContainer
}
